<template>
  <div class="skeleton-shimmer" :style="skeletonStyle"></div>
</template>

<script>
export default {
  name: 'SkeletonBase',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '20px',
    },
    borderRadius: {
      type: String,
      default: '4px',
    },
    backgroundColor: {
      type: String,
      default: '#3d3a35',
    },
  },
  computed: {
    skeletonStyle() {
      return {
        width: this.width,
        height: this.height,
        borderRadius: this.borderRadius,
        backgroundColor: this.backgroundColor,
      };
    },
  },
};
</script>

<style scoped>
.skeleton-shimmer {
  position: relative;
  overflow: hidden;
}

.skeleton-shimmer::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.08) 50%,
    transparent 100%
  );
  animation: shimmer 1.5s ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
